import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import {
    addProductType,
    AddOrUpdateProductTypeApiModel,
    ProductTypeModel,
} from "@tCentro/Services/CENAdminProductTypeService";

export interface AddProductTypeParameter extends HasOnSuccess<ProductTypeModel>, HasOnError<string> {
    model: AddOrUpdateProductTypeApiModel;
}

type HandlerType = ApiHandler<AddProductTypeParameter, { apiResult: ProductTypeModel }>;

export const AddProductType: HandlerType = async props => {
    try {
        const result = await addProductType(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to add product type");
        }
    }
};

export const chain = [AddProductType];
const addProductTypeData = createHandlerChainRunner(chain, "addProductTypeData");
export default addProductTypeData;
